import { css } from '@emotion/core';
import MediaQueries from '../../../styles/Grid/MediaQueries';
import { typography, fontWeights } from '../../../styles/typography';
import { colorsPalette } from '../../../styles/colors';
import { Edges, VIEWPORTS } from '../../../styles/Grid/GridSizes';

export const containerPaddingCss = {
  padding: '0 0 40px',
  [MediaQueries.md]: {
    padding: '0 0 48px',
  },
  [MediaQueries.lg]: {
    padding: '40px 0 64px',
  },
  [MediaQueries.xl]: {
    padding: '40px 0 0',
  },
};

export const containerMarginCss = {
  margin: '0 0 44px',
  [MediaQueries.md]: {
    margin: '0 0 56px',
  },
  [MediaQueries.lgAndUp]: {
    margin: '67px 0 78px',
  },
};

const headlineFontCss = css(typography.effra48, {
  [MediaQueries.xl]: {
    fontSize: '58px',
    lineHeight: '1',
  },
});

export const headlineCss = css(headlineFontCss, {
  position: 'relative',
  fontWeight: fontWeights.medium,
  marginBottom: 16,
  marginTop: 40,
  [MediaQueries.lg]: {
    marginTop: 30,
  },
});

export const subtitleCss = css(typography.effra18, {
  marginBottom: 16,
});

export const descriptionCss = css(typography.effra18, {
  color: colorsPalette.grey80,
  marginBottom: 16,
});

export const contactCss = css({
  display: 'flex',
  [MediaQueries.mdAndUp]: {
    alignItems: 'center',
    marginBottom: 32,
  },
});

export const getInTouchCss = css({
  display: 'none',
  minHeight: '100%',
  width: '100%',
  [MediaQueries.md]: {
    display: 'flex',
  },
  [MediaQueries.lgAndUp]: {
    display: 'inline-block',
    minHeight: 'auto',
  },
  ['a']: {
    minHeight: '100%',
  },
});

export const solutionInCtaCss = css({
  display: 'none',
  minHeight: '100%',
  [MediaQueries.mdAndUp]: {
    display: 'inline-block',
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 16,
    minHeight: 'auto',
  },
});

export const ctasNotLgCss = css({
  [MediaQueries.lgAndUp]: {
    display: 'none',
  },
});

export const ctasLgCss = css({
  display: 'none',
  [MediaQueries.lgAndUp]: {
    display: 'block',
  },
});

export const mainImageCss = css({
  width: '100%',
  display: 'block',
  [MediaQueries.md]: {
    paddingLeft: Edges[VIEWPORTS.md],
    paddingTop: 40,
  },
  img: {
    width: '100%',
  },
});

export const mainImageLgCss = isOneImageFromData =>
  css({
    img: {
      position: isOneImageFromData && 'absolute',
      marginBottom: isOneImageFromData ? -140 : 32,
      maxWidth: 556,
      position: 'relative',
      right: -85,
      width: '100%',
    },
  });

export const mainImageContainerCss = css({
  [MediaQueries.lg]: {
    padding: `0 ${Edges[VIEWPORTS.lg]}`,
    overflowX: 'hidden',
  },
});

export const mainImageLgContainerCss = isOneImageFromData =>
  css({
    [MediaQueries.lgAndUp]: {
      position: 'relative',
      lineHeight: 0,
      width: `calc(100% + ${Edges[VIEWPORTS.lg]}px)`,
      paddingBottom: 0,
      overflow: isOneImageFromData ? 'visible' : 'hidden',
    },
    [MediaQueries.xl]: {
      left: 4,
    },
  });

export const leftBottomImageColumnCss = css({
  [MediaQueries.lgAndUp]: {
    // Shows 175px of the left bottom image on XL.
    // Used to maintain the a proportional spacing.
    paddingBottom: '26.5%',
  },
});

export const leftBottomImageContainerCss = css({
  width: '78%',
  paddingLeft: '22%',
  position: 'absolute',
  [MediaQueries.lgAndUp]: {
    left: 0,
  },
});

export const leftBottomImageCss = css({
  img: {
    width: '100%',
  },
});

export const rightBottomImageContainerCss = css({
  width: `calc(100% + ${Edges[VIEWPORTS.lg]}px)`,
  position: 'absolute',
  overflow: 'hidden',
  [MediaQueries.lg]: {
    left: '-16px',
  },
  [MediaQueries.xl]: {
    left: '-12px',
  },
});

export const rightBottomImageCss = css({
  [MediaQueries.xl]: {
    left: 4,
    position: 'relative',
  },
  img: {
    maxHeight: 236,
    maxWidth: 421,
  },
});

export const customSpacerCss = css({
  [MediaQueries.lgAndUp]: {
    marginBottom: 160,
  },
});

export const fullHeight = isOneImageFromData =>
  css({
    height: isOneImageFromData ? '100%' : 'auto',
  });

export const rowFlex = css({
  alignContent: 'space-between',
  display: 'flex',
});
